<template>
    <div v-if="viewListOfUsers">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-else>
            <div class="col-lg-12 mb-4">
                <div class="box">
                    <div class="box-offset">
                        <div class="box-ttl">
                            SETTINGS - ADMINISTRATIVE USERS
                        </div>
                        <div class="buttons--row">
                            <div class="search--block">
                                <button
                                    @click="getUsersList"
                                    class="search--block-btn"
                                    type="submit">
                                    <img src="/img/svg/icons-search.svg" alt="search"></button>
                                <input
                                    type="search"
                                    v-model="filters.search"
                                    class="search--block-txt"
                                    @input="handleSearch"
                                />
                            </div>
                            <div class="filter-wrap">
                                <label for="" class="reg-label mr-2">Filter:</label>
                                <div class="form-group form-group-2 mb-0">
                                    <select
                                        class="custom-select"
                                        v-model="filters.status"
                                        @change.prevent="getUsersList"
                                    >
                                        <option value="all">All</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Deactivated</option>
                                    </select>
                                </div>
                            </div>
                            <a
                                v-if="creatingUser"
                                href="/master-admin/settings/users/create"
                                class="btn btn--outline-primary btn--middle">
                                + Add New
                            </a>
                        </div>
                        <div class="table-holder table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>
                                        <nobr>
                                            <a href="javascript:void(0)" @click.prevent="changeSortList('name')">
                                                First Name<i class="fas fa-sort"></i></a>
                                        </nobr>
                                    </th>
                                    <th>
                                        <nobr>
                                            <a href="javascript:void(0)" @click.prevent="changeSortList('last_name')">Last
                                                Name<i class="fas fa-sort"></i></a>
                                        </nobr>
                                    </th>
                                    <th>
                                        <nobr>
                                            <a href="javascript:void(0)" @click.prevent="changeSortList('phone')">Phone
                                                Number<i class="fas fa-sort"></i></a>
                                        </nobr>
                                    </th>
                                    <th>
                                        <nobr>
                                            <a href="javascript:void(0)" @click.prevent="changeSortList('email')">Email
                                                Address<i class="fas fa-sort"></i></a>
                                        </nobr>
                                    </th>
                                    <th>Job Title</th>
                                    <th style="width:6.625rem">Status</th>
                                    <th class="text-right">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="user in users" :key="user.id">
                                    <td>
                                        <a
                                            v-if="viewUserPage"
                                            :href="`/master-admin/settings/users/${user.id}/update`"
                                        >
                                            <b>
                                                {{ user.name }}
                                            </b>
                                        </a>
                                        <p v-else>
                                            <b>{{ user.name }}</b>
                                        </p>
                                    </td>
                                    <td>
                                        <a
                                            v-if="viewUserPage"
                                            :href="`/master-admin/settings/users/${user.id}/update`">
                                            <b>
                                                {{ user.last_name }}
                                            </b>
                                        </a>
                                        <p v-else>
                                            <b>{{ user.last_name }}</b>
                                        </p>
                                    </td>
                                    <td>
                                        {{ user.cell_number }}
                                    </td>
                                    <td>
                                        {{ user.email }}
                                    </td>
                                    <td>
                                        {{ user.job_title }}
                                    </td>
                                    <td>
                                        <VueToggles
                                            height="30"
                                            width="120"
                                            font-size="14"
                                            checkedText="Active"
                                            uncheckedText="Deactivated"
                                            checkedBg="#60ad45"
                                            uncheckedBg="#e0e1e2"
                                            :value="user.status === 'active'"
                                            @click="switchStatus(user)"
                                        />
                                    </td>
                                    <td class="text-right">
                                        <div class="action-block">
                                            <a :href="`/master-admin/settings/users/${user.id}/update?tab=Notes On Admin`" class="edit-link"><img
                                                src="/img/svg/notes.svg" alt=""></a>
                                            <button
                                                class="delete-link"
                                                @click="showDeleteModal(user.id)"
                                                v-if="deletingUser"
                                            >
                                                <img src="/img/svg/on.svg" alt="">
                                            </button>
                                            <ActionModal
                                                confirm-text="Yes"
                                                reject-text="No"
                                                :modalId="getDeleteModalId(user.id)"
                                                @confirm="deleteUser(user.id)"
                                            >
                                                <template #body>
                                                    <div class="text-center mb-4">
                                                        <h4>
                                                            Are you sure you want <br> to delete this item?
                                                        </h4>
                                                    </div>
                                                </template>
                                            </ActionModal>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            :currentPage="pagination.current_page"
                            :lastPage="pagination.last_page"
                            @changePage="changePage"
                            @changeItemsPerPage="changeItemsPerPage"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import UsersServices from "./services/UsersServices";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ListOfUsers',
    props: {
        viewListOfUsers: {
            type: Boolean,
            required: true
        },
        creatingUser: {
            type: Boolean,
            required: true
        },
        viewUserPage: {
            type: Boolean,
            required: true
        },
        deletingUser: {
            type: Boolean,
            required: true
        },
        deactivatingUser: {
            type: Boolean,
            required: true
        }

    },
    mixins: [ModalHandler, SortDirectionHandler, PaginationHandler],
    components: {
        Pagination,
       ActionModal
    },
    data() {
        return {
            loading: true,
            users: [],
            filters: {
                search: '',
                status: 'all',
                sortBy: 'status',
                sortDir: 'asc',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        getList(filters) {
            this.getUsersList(filters)
        },
        async getUsersList() {
            try {
                const {data: response } = await  UsersServices.getUsersList(this.filters)
                this.users = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        async switchStatus(user) {
            this.$showLoadingMessage()
            if (this.deactivatingUser) {
                user.status = user.status === 'active' ? 'inactive' : 'active'
                try {
                    await UsersServices.updateStatus(user.id, user.status);
                    this.$showSuccessMessage('Status has been changed')
                } catch (e) {
                    this.$showErrorMessage('Status was not changed')
                }
            } else {
                this.$showErrorMessage('You do not have access to change status' );
            }
        },
        async deleteUser(id) {
            this.$showLoadingMessage()
            this.users = this.users.filter((user) => user.id !== id)
            try {
                await UsersServices.delete(id)
                this.$showSuccessMessage('User was deleted')
            } catch (error) {
                this.$showErrorMessage('User was not deleted. Please try again')
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getUsersList()
        this.delayedSearch = createDebouncedFunction(() => this.getUsersList(), 500);
    }
}

</script>

<style scoped>

</style>
